import CustomToolbar from "componentsv2/form/CustomToolbar";
import TrytonForm from "componentsv2/form/TrytonForm";

function ShiftForm({ storeId, onAction, layout }) {
  if (!layout) return null;

  return (
    <div>
      <CustomToolbar layout={layout} storeId={storeId} onAction={onAction} />
      <TrytonForm storeId={storeId} layout={layout} />
    </div>
  );
}

export default ShiftForm;
